<template>
    <div class="text-nowrap">
        <EditButton
            v-if="canEdit"
            is-small
            :disabled="disabled"
            @click="handleEdit()" />

        <DestroyButton
            v-if="canDestroy"
            is-small
            :disabled="disabled"
            @click="handleDestroy()" />

        <MoveUpButton
            v-if="showSort"
            is-small
            hide-label
            :disabled="disabled || !canMoveUp"
            @click="handleMoveUp()" />

        <MoveDownButton
            v-if="showSort"
            is-small
            hide-label
            :disabled="disabled || !canMoveDown"
            @click="handleMoveDown()" />
    </div>
</template>

<script>
import DestroyButton from '@/js/components/common/buttons/DestroyButton';
import EditButton from '@/js/components/common/buttons/EditButton';
import MoveDownButton from '@/js/components/common/buttons/MoveDownButton';
import MoveUpButton from '@/js/components/common/buttons/MoveUpButton';

import ActionsMixin from '@/js/mixins/ActionsMixin';

export default {
    name: 'LinkActions',

    components: {DestroyButton, EditButton, MoveDownButton, MoveUpButton},

    mixins: [ActionsMixin],

    props: {
        api: {type: Object, required: true},
        link: {type: Object, required: true},
    },

    computed: {
        model() {
            return this.link;
        },

        confirmLabel() {
            return {link: this.link.name};
        },

        notificationsRoot() {
            return 'links';
        },
    },

    methods: {
        handleEdit() {
            this.$emit('edit');
        },
    },
};
</script>
